<template>
    <div class="quotesimage quotesimage-wrapper" :class="imgLast ? 'img-last' : ''" >
        <div class="quotesimage-image-wrapper">
            <canvas class="quotesimage-image"></canvas>
            <!-- <img class="quotesimage-image" :src="require(`@/assets/img/${quoteImage}`)" :alt="quoteText"> -->
        </div>

        <div class="quotesimage-quote-wrapper">
            <p class="quotesimage-quote">"{{ quoteText }}"</p>
            <span class="quotesimage-quote-author">- {{ quoteAuthor }}</span>
        </div>

    </div>
</template>

<script lang="ts">
    import Vue from 'vue';
    import * as PIXI from 'pixi.js';
    import { vw } from '@/utils/deviceDetect';

    export default Vue.extend({
        name: 'QuotesImage',
        props: {
            quoteText: String,
            quoteAuthor: String,
            quoteImage: String,
            imgLast: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            enable3dEffect() {
                const elementWrapper = document.querySelector('.quotesimage-wrapper') as HTMLDivElement;
                const imageWrapper   = document.querySelector('.quotesimage-image-wrapper') as HTMLDivElement;
                const canvasElement   = document.querySelector('.quotesimage-image') as HTMLCanvasElement;
                
                const app = new PIXI.Application({ width: window.innerWidth / 1.5, height: window.innerWidth / 1.5, transparent: true, view: canvasElement });
                
                app.view.classList.add('quotesimage-image');
                imageWrapper.appendChild( app.view );

                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const mapImage     = require(`@/assets/img/${ this.$props.quoteImage }`);
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const deahMapImage = require('@/assets/img/brain-mapb.png');

                const img  = PIXI.Sprite.from( mapImage );
                img.width  = window.innerWidth / 1.5 ;
                img.height = window.innerWidth / 1.5;
                img.anchor.x = 0;
                img.anchor.y = 0;
                app.stage.addChild( img );

                const deathMap = PIXI.Sprite.from( deahMapImage );
                deathMap.width  = window.innerWidth / 1.5 ;
                deathMap.height = window.innerWidth / 1.5;
                deathMap.anchor.x = 0;
                deathMap.anchor.y = 0;
                app.stage.addChild( deathMap );

                const displacementFilter = new PIXI.filters.DisplacementFilter( deathMap )
                app.stage.filters = [ displacementFilter ];

                if( vw > 992 ) {
                    elementWrapper.onmousemove = ( event: MouseEvent ) => {
                        displacementFilter.scale.x = ( elementWrapper.offsetWidth / 2 - event.clientX ) / 18;
                        displacementFilter.scale.y = ( elementWrapper.offsetHeight / 2 - event.clientY ) / 18;
                    }
                }
            }
        },
        mounted() {
            setTimeout(() => {
                if( vw > 992 )
                    this.enable3dEffect();
            }, 1000);
        }
    })
</script>

<style scoped lang="scss">
    .quotesimage {
        &-wrapper {
            display: grid;
            grid-template-columns: repeat(12, 1fr);
            grid-template-rows: 1fr;
            width: 100%;
            min-height: 40vh;
        }

        &-image {
            max-height: 60vh;
            width: 100%;
            height: 100%;
            object-fit: contain;
            position: relative;
            z-index: -1;
            &-wrapper {
                grid-column: 2 / span 10;
                grid-row: 1;
            }
        }

        &-quote {
            color: #fff;
            font-size: 2rem;
            user-select: none;

            &-wrapper {
                grid-column: 2 / span 10;
                grid-row: 1;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
            }

            &-author {
                color: #fff;
                letter-spacing: 1.5px;
                font-size: 1.1rem;
                margin-top: .8rem;
            }
        }

        @media SCREEN AND ( min-width: 768px ) {
            &-image {
                &-wrapper {
                    grid-column: 2 / span 6;
                }
            }

            &-quote {
                font-size: 3rem;
                &-wrapper {
                    grid-column: 7 / span 5;
                }
            }
        }

        @media SCREEN AND ( min-width: 1200px ) {
            &-quote {
                font-size: 5rem;
            }
        }

        &.img-last {

            @media SCREEN AND ( min-width: 768px ) {
                & .quotesimage-quote {
                    &-wrapper {
                        grid-column: 3 / span 7;
                    }
                }

                & .quotesimage-image {
                    font-size: 3rem;
                    &-wrapper {
                        grid-column: 5 / span 5;
                    }
                }
            }

            @media SCREEN AND ( min-width: 1200px ) {
                & .quotesimage-quote {
                    font-size: 5rem;
                }
            }
        }
    }

</style>